"use client";
import React from "react";
import ChallengeCard from "./ChallengeCard";

const ChallengeSection = () => {
  return (
    <section className="mt-6 w-full">
      <div className="pl-3 w-full text-lg font-semibold leading-loose text-gray-900">
        <h2 className="w-full">
          <div className="flex gap-4 w-full">
            <span className="flex-1 shrink w-full basis-0 min-w-60">
              Active Challenges
            </span>
          </div>
        </h2>
      </div>

      <ChallengeCard
        title="7-Day Goal Streak"
        badgeText="5 Days Left"
        badgeColor="blue"
        progressPercentage={28.5} // 2/7 days = ~28.5%
        progressColor="blue"
        description="2/7 days completed"
      />

      <ChallengeCard
        title="Community Challenge"
        badgeText="Active"
        badgeColor="green"
        progressPercentage={70} // Estimated from the design
        progressColor="green"
        description="Save 500L collectively this week"
        iconUrl="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/e138372ed79175c6259680e3cc3600e7f8396310?placeholderIfAbsent=true"
      />
    </section>
  );
};

export default ChallengeSection;
